export default __webpack_public_path__ + "media/5a355803983ea63c07e1c8ae8f44e5e881820cb01f7e09dea5e9c42397afdad8.svg";